import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
  import { useRoute } from 'vue-router';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

  const route = useRoute();

  const getComponent = computed(() => {
    return route.meta.layoutComponent;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent.value)))
}
}

})